import {
  compactFormat,
  dataLabelsCompact,
  dataLabelsDecimals,
  dataLabelsSizes,
  dimension,
  dimensionSelector,
  granularity,
  legendPosition,
  palette,
  showDataLabels,
  showItems,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME, FAMILY.COMPARISON, FAMILY.DISTRIBUTION],
  title: "Bar Chart",
  defaultHeight: 6,
  controls: [{ ...dimension, metricName: "yAxis" }, granularity],
  settings: {
    showItems: { ...showItems, gridPosition: [2, 0] },
    legendPosition: { ...legendPosition, gridPosition: [3, 0] },
    compactFormat: { ...compactFormat, gridPosition: [4, 0] },

    yAxis: {
      default: "channel",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "yAxis",
    },
    xAxisPrimary: {
      default: "spend",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    xAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [1, 1],
      forAxis: "xAxisPrimary",
    },
    palette,
  },
  planSettings: {
    showItems: { ...showItems, gridPosition: [2, 0] },
    legendPosition: { ...legendPosition, gridPosition: [3, 0] },
    compactFormat: { ...compactFormat, gridPosition: [4, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [6, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [6, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [7, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [7, 1] },
    yAxis: {
      default: "channel",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "yAxis",
    },
    xAxisPrimary: {
      default: "channel_budget",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    xAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [1, 1],
      forAxis: "xAxisPrimary",
    },
    palette,
  },
  familySettings: {
    [FAMILY.OVERTIME]: {
      legendPosition: { ...legendPosition, gridPosition: [2, 0] },
      compactFormat: { ...compactFormat, gridPosition: [3, 0] },
      showItems: undefined,

      yAxis: {
        default: "month",
        type: "select",
        label: "Vertical Axis Metric",
        dictionary: "timeMetrics",
        apiParameter: "dimension",
        gridPosition: [0, 0],
        tooltipOrder: 0,
      },
    },
    [FAMILY.COMPARISON]: {
      dimensionSelector: { ...dimensionSelector, gridPosition: [5, 0] },
    },
    [FAMILY.DISTRIBUTION]: {
      dimensionSelector: { ...dimensionSelector, gridPosition: [5, 0] },
    },
  },
};
